import React, { Component, PropTypes } from 'react'

import get from 'lodash/get'
import set from 'lodash/set'
import debounce from 'lodash/debounce'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import moment from 'moment'

import api from '../../api'
import Filters from '../crud/filters'

class FilterModal extends Component<any, any> {
  constructor (props) {
    super(props)

    this.state = {
      filters: {},
      autocompleteText: {},
      autocompleteResults: {}
    }
// @ts-ignore
    this.debouncedAutocompleteUpdate = debounce(this.performAutocompleteUpdate.bind(this), 500)
  }

  handleExport () {
    this.props.onExport(this.state.filters)
  }

  setFilterValue (filter, value) {
    const newState = { ...this.state }
    set(newState, filter, value)
    this.setState(newState)
  }

  getAutocompleteText () {
    this.props.filters.forEach(filter => {
      if (filter.type !== 'autocomplete' || !get(this.state, filter.prop)) {
        return
      }

      const body = {
        'filters[ids]': get(this.state, filter.prop)
      }

      api
        .get(filter.references, { body })
        .then(res => res.json())
        .then(collection => {
          if (!collection[0]) {
            return
          }

          this.setState({
            autocompleteText: Object.assign(this.state.autocompleteText, {
              [filter.references]: collection[0][filter.referenceProp]
            })
          })
        })
    })
  }

  handleAutocompleteUpdateInput (filter, searchText) {
    if (searchText === '' && get(this.state, filter.prop)) {
      this.setFilterValue(filter.prop, undefined)
    }

    // Debounce the API call
// @ts-ignore
    this.debouncedAutocompleteUpdate(filter, searchText)
  }

  performAutocompleteUpdate (filter, searchText) {
    const apiQuery = {
      filters: {
        [`${filter.referenceProp}_ilike`]: searchText
      },
      limit: 5
    }

    const { query = {} } = filter

    if (query.filters) {
      apiQuery.filters = Object.assign({ }, apiQuery.filters, query.filters)
    }

    if (query.order) {
// @ts-ignore
      apiQuery.order = query.order
    }

    if (filter.customFilters) {
      Object.keys(filter.customFilters).map(filterKey => {
        apiQuery[`filters[${filterKey}]`] = filter.customFilters[filterKey]
      })
    }

    api
      .get(filter.references, { body: apiQuery })
      .then(res => res.json())
      .then(collection => {
        this.setState({
          autocompleteResults: Object.assign({}, this.state.autocompleteResults, {
            [filter.references]: filter.dataHydrator ? filter.dataHydrator(collection) : collection
          })
        })
      })
  }

  handleAutocompleteSelection (filter, chosenRequest, selectedIndex) {
    if (selectedIndex === -1) {
      // enter pressed in the autocomplete field
      return
    }

    const idProp = filter.idProp || 'id'
    this.setFilterValue(filter.prop, chosenRequest[idProp])
  }

  handleFilterTextChange (filter, e) {
    this.setFilterValue(filter.prop, e.target.value || undefined)
  }

  handleFilterSelectChange (i, filter, e, key, val) {
    this.setFilterValue(filter.prop, val === null ? undefined : val)
  }

  handleDatePickerUpdate (filter, e, date) {
    this.setFilterValue(filter.prop, moment(date).format('YYYY-MM-DD'))
  }

  handleFilterMultipleSelectChange (filter, e, i, values) {
    this.setFilterValue(filter.prop, values)
  }

  handleFilterMultipleSelectChipDelete (filter, values, valueToBeDeleted) {
    this.setFilterValue(filter.prop, values.filter(value => value !== valueToBeDeleted))
  }

  render () {
    return (
      <Dialog
        title='Apply Filters'
        open
        actions={[
          <FlatButton
            label='Close'
            secondary
            onClick={this.props.onClose}
          />,
          <FlatButton
            label='Export'
            primary
            onClick={this.handleExport.bind(this)}
          />
        ]}
        onRequestClose={this.props.onClose}
      >
        <Filters
          values={{ filters: this.state.filters }}
          filters={this.props.filters}
          handleFilterTextChange={this.handleFilterTextChange.bind(this)}
          autocompleteText={this.state.autocompleteText}
          autocompleteResults={this.state.autocompleteResults}
          handleAutocompleteSelection={this.handleAutocompleteSelection.bind(this)}
          handleAutocompleteUpdateInput={this.handleAutocompleteUpdateInput.bind(this)}
          handleDatePickerUpdate={this.handleDatePickerUpdate.bind(this)}
          handleFilterMultipleSelectChange={this.handleFilterMultipleSelectChange.bind(this)}
          handleFilterMultipleSelectChipDelete={this.handleFilterMultipleSelectChipDelete.bind(this)}
          handleFilterSelectChange={this.handleFilterSelectChange.bind(this)}
        />
      </Dialog>
    )
  }
}

// @ts-ignore
FilterModal.propTypes = {
  filters: PropTypes.array.isRequired,
  onExport: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default FilterModal
